import { render, staticRenderFns } from "./groupsView.vue?vue&type=template&id=ca713ada&scoped=true&"
import script from "./groupsView.vue?vue&type=script&lang=js&"
export * from "./groupsView.vue?vue&type=script&lang=js&"
import style0 from "./groupsView.vue?vue&type=style&index=0&id=ca713ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca713ada",
  null
  
)

export default component.exports